import { render, staticRenderFns } from "./IconCloseCircleOutline.vue?vue&type=template&id=5f4b4b06&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports